import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AutoplayVideo from './AutoplayVideo';
import SlatImage from './Comps/SlatImage';

export class MediaDisplay extends PureComponent {
  static propTypes = {
    // TODO: Change this back to checking for ImageMediaObject or VideoMediaObject and not rendering if undefined
    media: PropTypes.object,
    imageSize: PropTypes.string,
    layout: PropTypes.oneOf(['left', 'right', 'center', 'custom']),
    isMobile: PropTypes.bool,
    canPlayVideo: PropTypes.oneOf([true, false, 'unknown']),
    isPreloadedCallback: PropTypes.func,
  };

  static defaultProps = {
    imageSize: 'cover',
    layout: 'center',
  };

  render() {
    let {
      className,
      media = {},
      isMobile,
      canPlayVideo,
      layout,
      imageSize,
      isPreloadedCallback,
    } = this.props;

    let { poster, mobilePoster } = media;

    // Check for mobilePoster first, if mobile.
    if (isMobile && mobilePoster) {
      poster = mobilePoster;
    }

    // If no poster is set, use the mobile or desktop image depending on platform.
    if (!poster) {
      poster = isMobile ? media.mobileImage : media.image;
    }

    let MediaComponent;

    // media will be an object
    if (media && media.type) {
      if (
        media.type === 'video' &&
        canPlayVideo &&
        media[isMobile ? 'mobileVideo' : 'video']
      ) {
        MediaComponent = AutoplayVideo;
      } else if (media.type === 'image' || media.type === 'video') {
        // If type is video and canPlayVideo is false then it has been deemed unplayable
        MediaComponent = SlatImage;

        // If the video is entering the fallback state, ensure that `image`s are set if they haven't been set already.
        // This makes sure they're set no matter where they came from (API or JSON file.)
        if (media.type === 'video' && media.poster) {
          if (!media.image && media.video) {
            media.image = media.poster;
          }
          if (!media.mobileImage && media.mobileVideo) {
            media.mobileImage = media.poster;
          }
        }
      }
    }

    return MediaComponent ? (
      <MediaComponent
        className={className}
        {...media}
        poster={poster}
        isMobile={isMobile}
        layout={layout}
        imageSize={imageSize}
        canPlayVideo={canPlayVideo}
        isPreloadedCallback={isPreloadedCallback}
      />
    ) : (
      <div className={className} />
    );
  }
}

const mapStateToProps = ({ env: { isMobile, canPlayVideo } }) => ({
  isMobile,
  canPlayVideo,
});

export default connect(mapStateToProps)(MediaDisplay);
